import {
  BlockOutlinedIcon,
  Cancel,
  CheckCircle,
  ChecklistOutlined,
  Error,
  HelpIcon,
} from '@/ui/primitives';
import type { SvgIconComponent } from '@/ui/primitives';

export const getStatusIconComponent = (status?: string | null): SvgIconComponent => {
  if (!status) return HelpIcon;
  if (status === 'passed') return CheckCircle;
  if (status === 'completed') return CheckCircle;
  if (status === 'errored') return Error;
  if (status === 'failed') return Cancel;
  if (status === 'skipped') return BlockOutlinedIcon;
  if (status === 'untested') return HelpIcon;
  return ChecklistOutlined;
};
